<template>
  <b-container fluid>
    <loading :active.sync="isGenerando" :is-full-page="true"></loading>
    <!----------------------------------------------------Collapse Pago en Linea------------------------------------------------------>
    <b-row v-if="servicios.pagoEnLinea "  align-h="center" no-gutters>
      <b-col cols="12" md="10" lg="7">
        <b-row no-gutters> 
          <b-col>
            <b-img src="@/assets/portadapagos.jpg" fluid-grow alt="Fluid-grow image"></b-img>
          </b-col>
        </b-row>

        <!--------- MUESTRA DATOS CARGADOS --------------->
        <b-row no-gutters  class="mt-5" v-if="folioPago!='' && folioPago!=null && seriePago!='' && seriePago!=null && montoPago!='' && montoPago!=null ">
          <b-col class="card-form-purple " style="padding:15px;">
            <b-row>
              <b-col cols="12">
                <h5 style="color: #2A59B7;"><b-icon icon="menu-button-wide-fill"/> Datos del Pago</h5>  
              </b-col>
            </b-row>
            <b-row style="font-size:20px;" class="mt-1 mb-3">              
              <b-col>
                <b-table class="text-left" thead-class="hidden_header" small :items="datosPago"/>
              </b-col>
            </b-row>          
          </b-col>
          
        </b-row>

        <!---------- MUESTRA FORMULARIO PARA INGRESAR DATOS NO CARGADOS------------------------------>
        <b-row no-gutters  class="mt-5">
          <b-col class="card-form-primary " style="padding:15px;">           
            <b-row>
              <b-col cols="12">  
                <b-alert variant="danger" dismissible @dismissed="cleanMsgError" :show="msgErrorContribuyente != ''">
                  {{msgErrorContribuyente}}
                </b-alert>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-alert variant="danger" dismissible :show="isShowMsgErrorCodigo" @dismissed="isShowMsgErrorCodigo=0" @dismiss-count-down="countDownChanged">
                  {{msgErrorCodigo}}
                </b-alert>
              </b-col>
            </b-row>

            <b-row>
              <b-col v-if="seriePago=='' || seriePago==null" class="mb-4">
                <h5>Ingrese la Serie y el Folio del Formato de Pago que desea pagar.</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="2" md="3" v-if="seriePago=='' || seriePago==null">
                <!---INGRESA SERIE, FOLIO Y MONTO --->
                <b-form-group>
                  <a>Serie:</a> <b title="Más información"><b-icon icon="question-circle-fill" font-scale="1.1" variant="success" @click="isShowInfoSerie=true"></b-icon></b><br>
                  <b-form-input class="input-serie" :state="!$v.seriePago.$invalid" type="text" v-model.trim="seriePago"></b-form-input>
                  <div class="error" v-if="!$v.seriePago.minLength">La serie debe contener tres carecteres. Ejemplo 'OAC'.</div>
                  <div class="error" v-if="!$v.seriePago.maxLength">La serie debe contener tres carecteres. Ejemplo 'OAC'.</div>
                  <div class="error" v-if="!$v.seriePago.required">Ingrese una serie de tres caracteres.</div>            
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="2" md="3"  v-if="folioPago=='' || folioPago==null">
                <b-form-group>
                  <a>Folio:</a> <b title="Más información"><b-icon icon="question-circle-fill" font-scale="1.1" variant="success" @click="isShowInfoFolio=true"></b-icon></b><br>
                  <b-form-input class="input-folio" :state="!$v.folioPago.$invalid" type="text" v-model.trim="folioPago"></b-form-input>     
                  <div class="error" v-if="!$v.folioPago.numeric">El Folio solo debe contener caracteres numéricos.</div>
                  <div class="error" v-if="!$v.folioPago.required">Ingrese un Folio numérico.</div>         
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="2" md="3"  v-if="montoPago=='' || montoPago==null">
                <b-form-group>
                  <a>Total a Pagar:</a> <b title="Más información"><b-icon icon="question-circle-fill" font-scale="1.1" variant="success" @click="isShowInfoMonto=true"></b-icon></b><br>
                  <b-form-input class="input-folio" :state="!$v.montoPago.$invalid" type="text" v-model.trim="montoPago"></b-form-input>     
                  <div class="error" v-if="!$v.montoPago.numeric">El Total solo debe contener caracteres numéricos.</div>
                  <div class="error" v-if="!$v.montoPago.required">Ingrese el Total a Pagar sin comas ni espacios.</div>
                  <div class="error" v-if="!$v.montoPago.between">La cantidad debe ser mayor a 1.</div>        
                </b-form-group>
              </b-col>
            </b-row>

             <!---- INGRESA CORREO ELECTRONICO---------->

            <b-row v-if="this.servicios.solicitaContactoPago">
              <b-col cols="12"><h5><b-icon icon="envelope"/> Para continuar con el pago ingrese un correo electrónico</h5></b-col>
              <b-col cols="12" md="6" lg="6" xl="5" >
                
                <b-form-group>
                  <b-form-input :state="!$v.emailPago.$invalid" type="text" v-model.trim="emailPago"></b-form-input>
                  <div class="error" v-if="!$v.emailPago.minLength">El Correo Electrónico es demasiado corto.</div>
                  <div class="error" v-if="!$v.emailPago.maxLength">El Correo Electrónico es demasiado largo.</div>
                  <div class="error" v-if="!$v.emailPago.required">Ingrese un Correo Electrónico.</div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="3">
                <vue-recaptcha ref="recaptchaPagos" sitekey="6LdD09sUAAAAANCvTN2xMZqvfMOvzkdkOB1Zcpok" @verify="captchaPagosFilled" @expired="captchaPagosExpired" :loadRecaptchaScript="true" />
              </b-col>
            </b-row>  
            <div class="error" v-if="isShowMsgCaptcha">Por favor complete el captcha.</div><br>
            <b-row>
              <b-col cols="12"  md="6" lg="4" xl="3">
                <b-button block size="lg" variant="success" :disabled="($v.emailPago.$invalid && this.servicios.solicitaContactoPago) || this.captchaPagos==null" @click="generarPagoEnLinea">Continuar <b-icon icon="arrow-right-circle"/></b-button>
              </b-col>
              <b-col class=" mt-3 mb-3" cols="12">Al dar click en continuar, aceptas nuestro <a :href="servicios.urlTerminos" target="_blank">Aviso de Privacidad, Términos y Condiciones.</a>.</b-col>
            </b-row>
              
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    
    <!--------------------------------------------------------------------- MODALS -------------------------------------------------------------------->

    <b-modal  modal-class="pagoenlinea-modal"  scrollable title="Pago En Línea" v-model="isShowModalInfoPagoEnLinea"  hide-footer>
     
      <b-row  no-gutters>
        <b-col cols="12" >
          <div style="margin-left:-17px; margin-right:-17px; margin-top:-20px;">
            <!--<b-embed  type="embed" :src="urlForPayment" allowfullscreen></b-embed>-->
            <iframe style="width:100%; height:1600px;" scrolling="no" :src="urlForPayment"></iframe>
          </div>          
          
        </b-col>
      </b-row>
    </b-modal>

    <b-modal title="Información" v-model="isShowInfoFolio" size="md" hide-footer>
      <b-row class="success" align-h="center">
        El Folio es un dato númerico.
      </b-row>
      <b-row class="row-to-img-orden" align-h="center">
        <b-img src="/imgs/orden_ico.jpg" width="400px"></b-img>
      </b-row>
    </b-modal>

    <b-modal title="Información" v-model="isShowInfoSerie" size="md" hide-footer>
      <b-row class="success" align-h="center">
        La Serie consta de tres caracteres.
      </b-row>
      <b-row class="row-to-img-orden" align-h="center">
        <b-img src="/imgs/orden_ico.jpg" width="400px"></b-img>
      </b-row>
    </b-modal>

    <b-modal title="Información" v-model="isShowInfoMonto" size="md" hide-footer>
      <b-row class="success" align-h="center">
        <!--Debe ingresar el total a pagar que aparece en el formato de pago.-->
        El Total a Pagar no debe contener comas ni signos de pesos.
      </b-row>
      <b-row class="row-to-img-orden" align-h="center">
        <b-img src="/imgs/orden_ico.jpg" width="400px"></b-img>
      </b-row>
    </b-modal>

    <b-modal title="Información" v-model="isShowInfoTotal" size="md" hide-footer>
      <b-row class="success" align-h="center">
        <!--Debe ingresar el total a pagar que aparece en el formato de pago.-->
        El Total Pagado no debe contener comas ni signos de pesos.
      </b-row>
      <b-row class="row-to-img-orden" align-h="center">
        <b-img src="/imgs/orden_ico.jpg" width="400px"></b-img>
      </b-row>
    </b-modal>

    
  </b-container>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { minLength, maxLength, required, numeric, between } from 'vuelidate/lib/validators';
import { mapState} from 'vuex';
import { server, getPostConfig, handledError, getGetConfig } from '@/axios-tools';
import axios from 'axios';
import VueRecaptcha from 'vue-recaptcha';
import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)


export default {
  computed:{
    ...mapState({
      parcialidades: state => state.contribuyente.parcialidades,
      totalLiquidacion: state => state.contribuyente.totalLiquidacion,
      isCalculando: state => state.contribuyente.isCalculando,
      isGenerando: state => state.contribuyente.isGenerando,
      idxUltParcialidad: state => state.contribuyente.idxUltParcialidad,
      msgErrorContribuyente: state => state.contribuyente.msgErrorContribuyente,
      msgErrorGenLinea: state => state.contribuyente.msgErrorGenLinea,
      terminosServicio: state => state.contribuyente.catalogContribuyente.terminosServicio,
      thems: state => state.contribuyente.catalogContribuyente.thems,
      test: state => state.contribuyente.test
    }),
    them(){
      var them;
      if(this.$route.params.municipio == this.thems.teotihuacan){
        them = this.thems.teotihuacan;
      }else if(this.$route.params.municipio == this.thems.demo){
        them =  this.thems.demo;
      }
      return them;
    }
  },
  data(){
    return{
      servicios:{
        facturacion: false,
        pagoAgua: false,
        pagoAnuncios: false,
        pagoBebidas: false,
        pagoComercio: false,
        pagoEnLinea: false,
        pagoEstacionamiento: false,
        pagoJuegos: false,
        pagoPadronMensual: false,
        pagoPanteon: false,
        pagoPredial: false,
        solicitaContactoPago : false
      },
      
      isShowFormVerificarCodigo:false,
      correoParaPago:null,
      seriePago:"",
      folioPago:"",
      emailPago:"",
      montoPago:"",
      datosPago:[],
      codigoVerificacion:"",
      isShowModalAceptarTerminos:false,
      isShowModalTerminos:false,
      isShowModalInfoPagoEnLinea:false,
      isShowMsgCaptcha:true,
      isShowInfoSerie:false,
      isShowInfoFolio:false,
      isShowInfoMonto:false,
      isShowInfoTotal:false,
      isShowAlertCodigoCorrecto:false,
      isShowMsgErrorCodigo:0,
      msgErrorCodigo:'',
      urlForPayment:'',
      captchaPagos: null,
    }
  },
  components: {
    VueRecaptcha,
    Loading
  },
  created: function () {
    this.getServices();

    //Se obtienen los datos de la url 
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.seriePago=urlParams.get('serie');
    this.folioPago=urlParams.get('folio');
    this.emailPago=urlParams.get('email');
    this.montoPago=urlParams.get('monto');
    var nombrePago=urlParams.get('nombre');
    var conceptoPago=urlParams.get('concepto');

    this.datosPago.push(
      {nombre:'Formato de pago', dato:this.seriePago+'-'+this.folioPago},
    );
    if(nombrePago!=null){
      this.datosPago.push(
          {nombre:'Nombre', dato:nombrePago},
      );
    }
    if(conceptoPago!=null){
      this.datosPago.push(
        {nombre:'Concepto principal', dato:conceptoPago},
      );
    }
    
    this.datosPago.push(
        {nombre:'Total a pagar', dato:'$ '+this.montoPago},
    );
    },
  methods:{
    getServices(){
      axios(
        getGetConfig(server.servicios, null, null, {codeClient:this.$route.params.municipio})
      )
      .then(res => {
        this.servicios = res.data;
      }).catch(err => {
        handledError(err, server.servicios, this.$router, this.$store);
      });
    },
    countDownChanged(isShowMsgErrorCodigo) {
      this.isShowMsgErrorCodigo = isShowMsgErrorCodigo;
    },
    
    cleanFormPago(){
      this.$refs.recaptchaPagos.reset();
      this.seriePago="";
      this.montoPago="";
      this.folioPago="";
      this.emailPago="";
      this.datosPago=[];
    },
    cleanMsgError(){
      /* Se manda cadena vacia a MsgErrorContribuyente en el store, ya que el <b-alert> para mostrar errores solo se muestra si este es diferente de cadena vacia */
      this.$store.commit("updateMsgErrorGenLinea", '');
    },
    captchaPagosFilled(token){
      this.captchaPagos = token;
      this.isShowMsgCaptcha = false;
    },
    captchaPagosExpired(){
      this.captchaPagos = null;
      this.isShowMsgCaptcha = true;
    },
    cleanResults(){
      /* Limpia toda la información de la liquidación en el store, cuando se manda una nueva petición */
      this.$store.commit("updateDatosPagoContribuyente", null);
      this.$store.commit("updateTotalLiquidacionContribuyente", null);
      this.$store.commit("updateMsgErrorContribuyente", '');
      this.isShowMsgCaptcha = true;
    },
    generarPagoEnLinea(){
      if(!this.isGenerando ){
        this.$store.commit("updateIsGenerandoContribuyente", true);
        this.cleanMsgError();
        axios(
            getPostConfig(server.generaPagoEnLinea, null, null, {serie:this.seriePago,folio:this.folioPago,total:this.montoPago,correo:this.emailPago,codeClient:this.$route.params.municipio})
        ).then(res => { 
            
            //this.urlForPayment = res.data;    por si se quiere mostrar embebido en un modal
            //this.isShowModalInfoPagoEnLinea = true;  por si se quiere mostrar embebido en un modal

            //window.location.href = res.data; si se quiere mostrar en la misma pagina

            window.open(res.data, '_blank');// si se quiere redireccionar a una nueva pagina

            this.$store.commit("updateIsGenerandoContribuyente", false);
        }).catch(err => {
            this.$store.commit("updateIsGenerandoContribuyente", false);
            handledError(err, server.generaPagoEnLinea, this.$router, this.$store);
        })
      }
    },
  },
  validations:{
    
    seriePago:{
            required,
            minLength: minLength(3),
            maxLength: maxLength(3)
    },
    folioPago:{
            required,
            numeric
    },
    montoPago:{
            required,
            numeric,
            between: between(1, 999999999)
    },
    emailPago:{
            required,
            minLength: minLength(5),
            maxLength: maxLength(200)
    },
    
  }
}
</script>
<style>
.row-to-img-orden{
  margin-left:40px;
}
.button-reenviar{
  margin-top: 5px;
}
.dropdown{
  margin-bottom: 5px;
}
.input-folio{
  margin-top:10px;
}
.input-serie{
  margin-top:10px;
}
.b-icon-info-recibo{
  margin-right:20px;
}
.margin-radio-recibo{
  margin-right:5px;
}
.margin-radio-linea{
  margin-right:5px;
}
.link-pdf{
  margin-left:20px;
}
.margin{
  margin: 5px auto;
}
div.error{
  color: red;
}
div.success{
  color: green;
  margin-bottom: 10px;
}

/*------------------------------------------------------------------------------- THEMS -------------------------------------------------------------------------- */
.teotihuacan:hover{
   background-color:#A03455;
   border-color:#A03455;
}
.teotihuacan{
   background-color:#9D2449; 
   border-color:#9D2449;
}
.demo:hover{
  background-color:#5F58B1;
   border-color:#5F58B1;
}
.demo{
  background-color:#312991; 
   border-color:#312991;
}
.pagoenlinea-modal .modal-dialog {
    height:100% !important;
    
}
.hidden_header {
  display: none;
}
</style>